import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ExcellenceCentersService } from '../../../services/excellenceCenters.service';
import { IndustriesService } from '../../../services/industries.service';
import { Industry } from '../../../models/Industry.model';
import { ExcellenceCenter } from '../../../models/ExcellenceCenter.model';
import { SupportCenter } from '../../../models/SupportCenter.model';
import { ToastsManager } from 'ng2-toastr';
@Component({
  selector: 'app-modal-apportionment',
  templateUrl: './modalApportionment.component.html',
  styleUrls: ['./modalApportionment.component.css']
})
export class ModalApportionmentComponent implements OnInit {
  @Input() isBillingLetter: boolean;
  @Input() apportionment:{
    industries: Industry[],
    excellenceCenters: ExcellenceCenter[],
    supportCenters: SupportCenter[]
  }
  @Input() totalValue: number;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter();
  @Output() modalData: EventEmitter<any> = new EventEmitter();
  percentAuxExcellenceCenter: number = 0;
  percentAuxSupportCenter: number = 0;
  percentAuxIndustry: number = 0;
  industryItems: any[] = new Array<any>();
  excellenceCentersItems: any[] = new Array<any>();
  supportCentersItems: any[] = new Array<any>();
  disableSave: boolean = true;
  totalValueExists:boolean = false;

  constructor(
    private excellenceCenterService: ExcellenceCentersService,
    private industriesService: IndustriesService,
    public toastr: ToastsManager
  ) { }

  async ngOnInit() {
    await this.createList();
  };

  async createList() {
    const allExcellenceAndSupportCenter = await this.excellenceCenterService.getAll();

    this.industryItems = await this.industriesService.getAll();
    this.industryItems = this.loadPercent(this.industryItems);

    this.excellenceCentersItems = allExcellenceAndSupportCenter.filter(ec => ec.type == 1);
    this.excellenceCentersItems = this.loadPercent(this.excellenceCentersItems);

    this.supportCentersItems = allExcellenceAndSupportCenter.filter(ec => ec.type == 2);
    this.supportCentersItems = this.loadPercent(this.supportCentersItems);

    if(this.isBillingLetter)
      this.supportCentersItems = this.whenIsBillingLetter(this.supportCentersItems)
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.apportionment){
      if(changes.apportionment.currentValue && changes.apportionment.currentValue.industries && changes.apportionment.currentValue.industries.length > 0){
        if(this.isBillingLetter){
          this.industryItems = this.industryItems.map(industry => {
            if(industry._id == changes.apportionment.currentValue.industries[0]._id ){
              this.percentAuxIndustry = 100;
              return {...industry, percentage:100}
            }else{
              return {...industry, percentage:0}
            }
          })
        } else {
          let ids = changes.apportionment.currentValue.industries.map(industry => {
              if (industry && industry._id) return industry._id
          });
          let sumPercentage = 0;
          this.industryItems = this.industryItems.map(industry => {
            if(ids.includes(industry._id)){
              let industryAUX = changes.apportionment.currentValue.industries.filter(eC => eC._id == industry._id);
              let percentageSumForDuplicateIndustries = 0;
              if (industryAUX.length > 1) {
                  industryAUX.forEach(industry => {
                      if (industry && industry.percentage)
                      percentageSumForDuplicateIndustries += Number(industry.percentage);
                  })
              }
              sumPercentage += percentageSumForDuplicateIndustries || parseInt(industryAUX[0].percentage);
              return {...industry, percentage: percentageSumForDuplicateIndustries || industryAUX[0].percentage }
            } else {
              return {...industry, percentage:0}
            }
          })
          this.percentAuxIndustry = sumPercentage;
        }
      } else {
        this.percentAuxIndustry = 0;
      }

      if(changes.apportionment.currentValue && changes.apportionment.currentValue.excellenceCenters && changes.apportionment.currentValue.excellenceCenters.length > 0) {
        let ids = changes.apportionment.currentValue.excellenceCenters.map(excellenceCenter => excellenceCenter._id);
        let sumPercentage = 0;
        this.excellenceCentersItems = this.excellenceCentersItems.map(excellenceCenter => {
        if(ids.includes(excellenceCenter._id)){
            let excellenceCenterAUX = changes.apportionment.currentValue.excellenceCenters.filter(eC => eC._id == excellenceCenter._id);
            sumPercentage += excellenceCenterAUX[0].percentage;
            return {...excellenceCenter, percentage: excellenceCenterAUX[0].percentage}
        }else{
            return {...excellenceCenter, percentage:0}
        }
        })
        this.percentAuxExcellenceCenter = sumPercentage;
      } else {
        this.percentAuxExcellenceCenter = 0;
      }

      if(changes.apportionment.currentValue && changes.apportionment.currentValue.supportCenters && changes.apportionment.currentValue.supportCenters.length > 0) {
        let ids = changes.apportionment.currentValue.supportCenters.map(supportCenter => supportCenter._id);
        let sumPercentage = 0;
        this.supportCentersItems = this.supportCentersItems.map(supportCenter => {
        if(ids.includes(supportCenter._id)){
            let supportCenterAUX = changes.apportionment.currentValue.supportCenters.filter(sC => sC._id == supportCenter._id);
            sumPercentage += supportCenterAUX[0].percentage;
            return {...supportCenter, percentage: supportCenterAUX[0].percentage}
        }else{
            return {...supportCenter, percentage:0}
        }
        })
        this.percentAuxSupportCenter = sumPercentage;
      } else {
        this.percentAuxSupportCenter = 0;
        if(this.isBillingLetter)
          this.percentAuxSupportCenter = 100;
      }

    }

    if(changes.totalValue && changes.totalValue.currentValue){
      this.totalValueExists = true
    }
  };

  loadPercent(list){
    let listLoaded = list.map(ecaux => {
      return {
        ...ecaux,
        percentage:0
      }
    });
    return listLoaded;
  }

  validatePercentage(item, aux){
    this[aux] = this.calcPercent(item)
    if(!this.totalValueExists)
      return

    this[item] = this[item].map(i=>{
      let percentValue = this.totalValue / 100 * i.percentage
      i.value = percentValue
      return i
    })
  }

  changePercent(item, aux) {
    this[item] = this[item].map(i=>{
      if(!i.percentage && i.percentage != 0 || i.percentage > 100 || i.percentage < 0)
         i.percentage = 0
      return i
    })
    this[aux] = this.calcPercent(item)
    if(this.percentAuxExcellenceCenter != 100 || this.percentAuxSupportCenter != 100 || this.percentAuxIndustry != 100){
      this.disableSave = true
    } else{
      this.disableSave = false
    }
  }

  calcPercent(item){
    let percentage = this[item].reduce((acc, { percentage }) => {
        const value = parseFloat(percentage)
        if (Number.isNaN(value)) {
            return acc
        }
        return acc + value
    }, 0)
    return percentage
  }

  whenIsBillingLetter(list){
    let othersLoaded = list.map((sc)=>{
      if(sc._id == '61b7960e46958f43020229c4'){ // Id - Área de Suporte: Others
        return {...sc, percentage:100}
      }else{
        return {...sc, percentage:0}
      }
    })
    return othersLoaded
  }

  async save(){
    if(this.percentAuxExcellenceCenter != 100 || this.percentAuxSupportCenter != 100 || this.percentAuxIndustry != 100){
      this.toastr.warning('A porcentagem total de cada rateio deve ser 100%');
      return;
    };

    const apportionmentResult = {
      excellenceCenters: this.excellenceCentersItems,
      supportCenters: this.supportCentersItems,
      industries: this.industryItems
    };
    this.modalData.emit(apportionmentResult);
    await this.createList();

    this.closeModal.emit()
  }

  async closeModalApportionment() {
    await this.createList();
    this.closeModal.emit()
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/apportionment/modalApportionment.component.ts